import { Close } from '@mui/icons-material';

import React from 'react';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import { Card, Divider, Modal, Slide } from '@mui/material';
import Gene20Button from '../../../Components/Gene20Button';
import Gene20Typography from '../../../Components/Gene20Typography';

import shopsData from '../data/shopsData';
import MotiModal from './Modal';
import { useState } from 'react';

export default function ProductModal() {
  const [show, setShow] = useState(false);
  const toggleModal = () => setShow(!show);
  return (
    <Gene20Box>
      {shopsData.map((product, index) => (
        <MotiModal product={product} key={index} />
        // <Modal
        //   key={index}
        //   open={show}
        //   onClose={toggleModal}
        //   sx={{
        //     width: '100%',
        //     display: 'flex',
        //     justifyContent: 'center',
        //     alignItems: 'center',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        //   }}
        // >
        //   <Slide direction="left" in={show} timeout={500}>
        //     <Gene20Box
        //       position="relative"
        //       width="500px"
        //       display="flex"
        //       flexDirection="column"
        //       borderRadius="xl"
        //       // bgColor="white"
        //       sx={{
        //         backgroundColor: 'blue',
        //         margin: '2vh',
        //         color: 'aqua',
        //       }}
        //       shadow="xl"
        //     >
        //       <Gene20Box display="flex" alginItems="center" justifyContent="space-between">
        //         <Close fontSize="medium" sx={{ cursor: 'pointer' }} onClick={toggleModal} />
        //         <Gene20Box sx={{ display: 'block', width: '100%' }}>
        //           <Gene20Typography
        //             variant="h5"
        //             sx={{
        //               fontVariant: 'all-small-caps',
        //               display: 'flex',
        //             }}
        //           >
        //             {product.name}
        //           </Gene20Typography>
        //           <Card
        //             component="img"
        //             sx={{ overflow: 'hidden', width: '50%', mb: '1rem' }}
        //             height="200px"
        //             key={index}
        //             src={product.image}
        //           />
        //         </Gene20Box>
        //       </Gene20Box>
        //       <Divider sx={{ my: 0 }} />
        //       <Gene20Box p={2}>
        //         <Gene20Typography variant="body2" color="secondary" fontWeight="regular">
        //           Society has put up so many boundaries, so many limitations on what&apos;s right
        //           and wrong that it&apos;s almost impossible to get a pure thought out.
        //           <br />
        //           <br />
        //           It&apos;s like a little kid, a little boy, looking at colors, and no one told him
        //           what colors are good, before somebody tells you you shouldn&apos;t like pink
        //           because that&apos;s for girls, or you&apos;d instantly become a gay two-year-old.
        //         </Gene20Typography>
        //       </Gene20Box>
        //       <Divider sx={{ my: 0 }} />
        //       <Gene20Box display="flex" justifyContent="space-between" p={1.5}>
        //         <Gene20Button variant="gradient" color="dark" onClick={toggleModal}>
        //           close
        //         </Gene20Button>
        //         <Gene20Button variant="contained">order</Gene20Button>
        //       </Gene20Box>
        //     </Gene20Box>
        //   </Slide>
        // </Modal>
      ))}
    </Gene20Box>
  );
}
